export interface BulkTargetingWizardStepProps {
  stepIsValid: (flag: boolean) => void;
}

export interface BulkTargetingApiResponseModel {
  hasExclusions: boolean;
  hasMarketOrProspect: boolean;
  hasTargets: boolean;
  isReadOnly: boolean;
  projectId: number;
  projectName: string;
  templateName: string;
}

export enum BulkTargetingWizardSteps {
  "SelectProjects",
  "ImportList",
  "ConfigureReport",
}

export interface ImportBulkTargetingFileResponseModel{
  bulkTargetId: number;
  recordCount: number;
  uploadLimitationStatus: number;
}

export enum BulkTargetExistingTargetActionEnum{
    Append = "append",
    Replace = "replace",
}

export interface BulkCreateProviderTargetingModel{  
  bulkTargetId: number;
  customProjectIds: number[];
  emailOnSuccess: boolean;
  exportName: string;
  formatType: string;
  existingTargetAction: BulkTargetExistingTargetActionEnum;
  reasonDescription: string;
  reasonName: string;
  isDistinctServicingProviderReport: boolean;
}
